import { ObjectMapper } from 'json-object-mapper';
import { Model, OptionModel } from '../model';
import { IModel } from '../IModel';
import { JobTitleDocumentModel } from './jobTitleDocument.model';
import { CompetenceMatrixModel } from './competenceMatrix.model';

export class JobTitleModel extends Model implements IModel<JobTitleModel> {
  title: string = '';
  description: string = '';
  cbo: string = '';
  code: string = '';
  salary: number = 0;
  salaryScaleId?: string | undefined = undefined;
  companyId: string | undefined = undefined;
  companyName: string | undefined = undefined;
  companyGroupId: string | undefined = undefined;
  jobTitleGroupId: string | undefined = undefined;
  jobTitleSeniorizationId: string | undefined = undefined;
  jobTitleDocuments: JobTitleDocumentModel[] = [];
  jobTitleGroupCompetenceMatrices?: CompetenceMatrixModel[] = [];
  competenceMatrices?: CompetenceMatrixModel[] = [];
  required: boolean = false;
  requirePreliminaryCourse: boolean = false;
  isApprentice: boolean = false;

  static create(input: any): JobTitleModel {
    return ObjectMapper.deserialize<JobTitleModel>(JobTitleModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  toOption(): OptionModel {
    return { label: `${this['code']} - ${this['title']} - R$ ${this['salary']}`, value: this.id } as OptionModel;
  }
}
